import { OrderStatus, orderStatusFromInt } from './orderStatus';

// UI stage machine — subset of flutter_client lib/enums/main_screen_stage.dart
// relevant to the MVP A→B web flow.
export type Stage =
  | 'NO_LOCATION'
  | 'NO_ORDER'
  | 'BUILD_ROUTE'
  | 'TRAVEL_OPTIONS'
  | 'SEARCH_DRIVER'
  | 'PLANNED_SEARCH_DRIVER'
  | 'DRIVER_ON_THE_WAY'
  | 'DRIVER_IS_WAITING'
  | 'TRIP_IN_PROGRESS'
  | 'AWAITING_PAYMENT'
  | 'DRIVER_CANCELLED_ORDER'
  | 'ORDER_CLOSED';

// Mirror of MainCubit._updateStateBasedOnOrder mapping in
// flutter_client lib/views/main/cubit/main_cubit_order_flow.dart.
export function stageFromStatusId(statusId: number | null | undefined): Stage {
  const status = orderStatusFromInt(statusId);
  switch (status) {
    case OrderStatus.Created:
      return 'SEARCH_DRIVER';
    case OrderStatus.PreOrder:
      return 'PLANNED_SEARCH_DRIVER';
    case OrderStatus.Accepted:
      return 'DRIVER_ON_THE_WAY';
    case OrderStatus.CarArrived:
      return 'DRIVER_IS_WAITING';
    case OrderStatus.ClientOnBoard:
      return 'TRIP_IN_PROGRESS';
    case OrderStatus.Completed:
      return 'AWAITING_PAYMENT';
    case OrderStatus.Paid:
      return 'AWAITING_PAYMENT';
    case OrderStatus.Rejected:
      return 'DRIVER_CANCELLED_ORDER';
    case OrderStatus.CarNotFound:
      return 'NO_ORDER';
    default:
      return 'SEARCH_DRIVER';
  }
}

// True while the order is live and we should keep polling.
export function isActiveOrderStatus(statusId: number | null | undefined): boolean {
  const status = orderStatusFromInt(statusId);
  return (
    status === OrderStatus.Created ||
    status === OrderStatus.PreOrder ||
    status === OrderStatus.Accepted ||
    status === OrderStatus.CarArrived ||
    status === OrderStatus.ClientOnBoard ||
    status === OrderStatus.Completed
  );
}

export const STAGE_LABEL: Record<Stage, string> = {
  NO_LOCATION: 'Визначаємо локацію…',
  NO_ORDER: 'Куди їдемо?',
  BUILD_ROUTE: 'Підтвердіть точку подачі',
  TRAVEL_OPTIONS: 'Оберіть тариф',
  SEARCH_DRIVER: 'Шукаємо водія…',
  PLANNED_SEARCH_DRIVER: 'Заплановано',
  DRIVER_ON_THE_WAY: 'Водій у дорозі',
  DRIVER_IS_WAITING: 'Водій очікує',
  TRIP_IN_PROGRESS: 'У дорозі',
  AWAITING_PAYMENT: 'Оплата',
  DRIVER_CANCELLED_ORDER: 'Замовлення скасовано',
  ORDER_CLOSED: 'Поїздку завершено',
};
